module.exports = __webpack_public_path__ + "img/1440.d4209790.jpg";